/* eslint-disable no-unused-vars */
<template>
  <div id="mobilenav" :class="topNavActiveClass">
    <div class="navContent" :class="{ pablo: pablo }">
      <a
        href="https://cubs.fanportal-mlb.com/artists"
        v-ePitchTracking="{
          site: siteId,
          category: 'Project Navigation',
          label: 'Home',
        }"
        :class="{ show: openMenu }"
      >
        <slot></slot
      ></a>

      <svg width="20" height="10" viewBox="0 0 20 10" xmlns="http://www.w3.org/2000/svg" v-if="!openMenu" v-bind:class="'hamburger-desktop'" v-bind:svg-inline="''" @click="toggleNav()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#BCBCBC" fill-rule="evenodd"><path d="M0 0h20v2H0zM0 4h20v2H0zM0 8h20v2H0z"/></g></svg>
      <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:class="'close-desktop'" v-bind:svg-inline="''" @click="toggleNav()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#BCBCBC" fill-rule="evenodd"><path d="M.121 10.243l9.9-9.9 1.414 1.414-9.9 9.9z"/><path d="M1.535.343l9.9 9.9-1.414 1.414-9.9-9.9z"/></g></svg>
    </div>
    <div class="mainMenu" :class="{ active: openMenu }">
      <b-nav class="navMob" v-b-scrollspy="100">
        <b-nav-item
          v-for="(section, index) in [
            { link: 'https://cubs.fanportal-mlb.com/artists', title: 'HOME' },
            {
              link: 'https://cubs.fanportal-mlb.com/artists/louisdeguzman',
              title: 'LOUIS DE GUZMAN',
            },
          ]"
          :key="index"
          :href="section.link"
          @click="toggleNav()"
          :class="{ active: openMenu }"
          v-ePitchTracking="{
            site: siteId,
            category: 'Link - Mobile Nav',
            label: section.anchor,
          }"
          >{{ section.title }}</b-nav-item
        >
        <div class="previousCollection">
          <h4 @click="secondaryLevelOpen = !secondaryLevelOpen">
            2021 COLLECTION
            <div class="underscore" :class="{ active: secondaryLevelOpen }" />
          </h4>
          <div
            class="previousCollection__links"
            :class="{ active: secondaryLevelOpen }"
          >
            <b-nav-item
              v-for="(section, index) in [
                {
                  link: 'https://cubs.fanportal-mlb.com/artists/bhm',
                  title: 'NIKKO WASHINGTON',
                },
                {
                  link: 'https://cubs.fanportal-mlb.com/artists/whm',
                  title: 'KATE LYNN LEWIS',
                },
                {
                  link: 'https://cubs.fanportal-mlb.com/artists/pennypinch',
                  title: 'PENNY PINCH',
                },
                {
                  link: 'https://cubs.fanportal-mlb.com/artists/efdot',
                  title: 'EFDOT',
                },
                {
                  link: 'https://cubs.fanportal-mlb.com/artists/samkirk',
                  title: 'SAM KIRK',
                },
                {
                  link: 'https://cubs.fanportal-mlb.com/artists/pabloserrano',
                  title: 'PABLO SERRANO',
                },
              ]"
              :key="index"
              :href="section.link"
              @click="toggleNav()"
              :class="{ active: openMenu }"
              v-ePitchTracking="{
                site: siteId,
                category: 'Link - Mobile Nav',
                label: section.anchor,
              }"
              >{{ section.title }}</b-nav-item
            >
          </div>
        </div>
      </b-nav>
      <svg width="149" height="34" viewBox="0 0 149 34" xmlns="http://www.w3.org/2000/svg" v-bind:class="'respect-logo'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M111.485 32.474c-8.583 0-15.566-6.984-15.566-15.566s6.983-15.564 15.566-15.564c5.66 0 10.625 3.038 13.349 7.569l-4.505 2.785c-1.789-3.024-5.083-5.057-8.844-5.057-5.662 0-10.27 4.606-10.27 10.267 0 5.663 4.608 10.27 10.27 10.27 3.761 0 7.055-2.034 8.844-5.058l4.505 2.786c-2.724 4.53-7.688 7.568-13.349 7.568zm8.296-12.273a8.925 8.925 0 01-8.296 5.632 8.924 8.924 0 110-17.848 8.925 8.925 0 018.296 5.632l6.848-4.234C123.86 3.822 118.12 0 111.485 0c-9.34 0-16.91 7.57-16.91 16.908 0 9.34 7.57 16.91 16.91 16.91 6.635 0 12.375-3.822 15.144-9.382l-6.848-4.235z" fill="#FFF"/><path fill="#00306B" d="M126.105 27.568h.394v1.073h.267v-1.073h.393v-.233h-1.054zM128.486 27.335l-.316.853h-.007l-.303-.853h-.463v1.306h.267v-1.039h.006l.366 1.039h.259l.377-1.039h.006v1.039h.267v-1.306z"/><path d="M120.329 22.12c-1.789 3.024-5.083 5.057-8.844 5.057-5.662 0-10.269-4.607-10.269-10.269 0-5.661 4.607-10.267 10.27-10.267 3.76 0 7.054 2.033 8.843 5.057l4.505-2.785c-2.724-4.531-7.688-7.57-13.349-7.57-8.583 0-15.566 6.983-15.566 15.565 0 8.583 6.983 15.566 15.566 15.566 5.66 0 10.625-3.038 13.349-7.569l-4.505-2.785z" fill="#CE0E2D"/><path d="M7.025 11.087H3.617v4.892h3.408c1.588 0 2.629-1.015 2.629-2.446 0-1.431-1.041-2.446-2.629-2.446zm2.81 15.3l-3.616-7.39H3.617v7.39H0V7.86h7.26c3.772 0 6.01 2.576 6.01 5.672 0 2.602-1.587 4.215-3.382 4.866l4.137 7.988h-4.19zM19.616 26.387V7.86h12.203v3.226h-8.586v4.345h7.311v3.227h-7.311v4.501h8.586v3.227zM43.057 26.543c-2.81 0-4.944-.599-6.766-2.446l2.342-2.342c1.171 1.17 2.759 1.561 4.476 1.561 2.133 0 3.278-.806 3.278-2.29 0-.65-.182-1.197-.572-1.56-.365-.339-.781-.521-1.64-.65l-2.238-.313c-1.587-.234-2.757-.729-3.59-1.535-.884-.885-1.327-2.082-1.327-3.643 0-3.305 2.446-5.62 6.453-5.62 2.55 0 4.397.624 5.985 2.16l-2.29 2.263c-1.171-1.118-2.576-1.275-3.8-1.275-1.925 0-2.861 1.067-2.861 2.342 0 .468.156.962.546 1.327.365.338.963.625 1.717.728l2.186.313c1.691.234 2.758.702 3.538 1.43.99.937 1.432 2.29 1.432 3.93 0 3.59-2.992 5.62-6.87 5.62M62.933 11.087H59.55v5.074h3.383c1.639 0 2.68-1.015 2.68-2.524 0-1.509-1.041-2.55-2.68-2.55m.182 8.326H59.55v6.974h-3.617V7.86h7.182c3.825 0 6.114 2.628 6.114 5.776 0 3.149-2.29 5.776-6.114 5.776M74.872 26.387V7.86h12.204v3.226H78.49v4.345h7.312v3.227h-7.312v4.501h8.587v3.227zM143.476 11.087v15.3h-3.616v-15.3h-4.84V7.861h13.297v3.226z" fill="#FFF"/></g></svg>
    </div>
  </div>
</template>
    
<script>
import { mapState } from "vuex";
import axios from "axios";
import { navData } from "@/data/navData";
export default {
  name: "MobileNav",
  props: {
    siteId: {
      type: String,
      required: true,
    },
    pablo: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      primaryLinks: navData(),
      topNavActiveClass: "",
      openMenu: false,
      secondaryLevelOpen: false,
    };
  },
  watch: {
    pablo: {
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollListener);
  },
  methods: {
    scrollListener() {
      const scrollY = window.scrollY;
      const gHeight = 38;
      const imgHeight = Math.min(611, window.innerWidth) * 0.1892;
      const bp = imgHeight * 0.5;
      const ep = bp + imgHeight;
      const diff = ep - bp;
      const prog = Math.min(Math.max(scrollY - bp, 0), ep);
      const multiplier = Math.min(Math.max(prog / diff, 0), 1);

      const ele = document.getElementById("logoHeader");
      if (!ele) return;
      ele.style.transform = `scale(${multiplier})`;
      ele.style.opacity = multiplier;
    },
    toggleNav() {
      const newVal = !this.openMenu;
      this.openMenu = newVal;
      document.documentElement.style.overflow = !newVal ? "auto" : "hidden";
    },
    scrollInit() {
      if (document.documentElement.scrollTop > 0) {
        this.topNavActiveClass = "active";
      } else {
        this.topNavActiveClass = "";
      }
    },
    onActivate(target) {
      axios
        .post(process.env.VUE_APP_API_URL + "/api/router/Tracking.php", {
          site: this.currentRouteName,
          action: "tracking",
          label: target,
          category: "Scrolled To",
        })
        .catch(() => {
          window.console.log("failed tracking");
        });
    },
  },
  created() {
    window.addEventListener("scroll", this.scrollInit);
    this.$root.$on("bv::scrollspy::activate", this.onActivate);
  },

  destroyed() {
    window.removeEventListener("scroll", this.scrollInit);
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    ...mapState(["global"]),
  },
};
</script>
    
<style lang="scss" scoped>
#mobilenav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  background: #ffffff;
  transition: background-color 0.5s ease-in-out;
  // &.active{
  //   background-color: #000000;
  // }
  #logoHeader {
    height: 38px;
    width: auto;
    opacity: 0;
    transition: all 75ms linear;
    transform: scale(0);
  }
  .show {
    height: 38px !important;
    opacity: 1 !important;
    transition: all 250ms ease-in;
  }
}
.hamburger-desktop {
  width: 20px;
  height: 10px;
  margin-left: 19px;
  cursor: pointer;
  outline: none;
}
.close-desktop {
  width: 12px;
  height: 12px;
  margin-left: 19px;
  cursor: pointer;
  outline: none;
}
.mainMenu {
  height: calc(100% - 54px);

  background-image: url("~@/assets/images/bg/texture_vertical.png");
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center;
  position: fixed;
  top: 54px;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  transition: all 0.25s ease-in-out;
  visibility: hidden;
  opacity: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  z-index: 100;
  padding-bottom: 35px;
  .navMob {
    margin-top: 42px;
    width: 100%;
    flex: 1;
  }
  &.active {
    visibility: visible;
    opacity: 1;
  }
  li {
    list-style: none;
    padding: 8px 0;

    a {
      width: 100%;

      text-transform: uppercase;
      font-family: Poppins-Bold;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 22px;
      transition: all 0.2s ease-in-out;
    }
  }
}
.respect-logo {
  width: 149px;
  max-width: 90vw;
  height: auto;
}

.navContent {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 54px;
  padding: 0 20px;
  &.pablo {
    padding-right: 120px;
    @media (max-width: $sm) {
      padding-right: 105px;
    }
  }
}

.nav-link {
  padding: 0 10px;
}

.nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.previousCollection {
  display: flex;
  flex-direction: column;
  h4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-transform: uppercase;
    font-family: Poppins-Bold;
    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 22px;
    cursor: pointer;
    margin-bottom: 10px;
    // width: fit-content;
    transition: all 0.2s ease-in-out;
    .underscore {
      width: 85%;
      height: 2px;
      background-color: #eaeaea;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
      &.active {
        opacity: 1;
      }
    }
  }
  &__links {
    height: fit-content;
    max-height: 0;
    transition: max-height 0.3s ease-in-out;
    overflow: hidden;
    &.active {
      max-height: 500px;
      transition: max-height 0.3s ease-in-out;
    }
    li {
      a {
        font-size: 14px;
      }
    }
  }
}

.mobileMenuBtn {
  height: 17px;
  width: 20px;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
  z-index: 4 !important;
  span {
    display: block;
    position: absolute;
    height: 3px;
    width: 100%;
    background: rgb(188, 188, 188);
    border-radius: 9px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
    &:nth-child(1) {
      top: 0px;
    }
    &:nth-child(2) {
      top: 7px;
    }
    &:nth-child(3) {
      top: 14px;
    }
  }
  &.active {
    span {
      &:nth-child(1) {
        top: 7px;
        transform: rotate(135deg);
      }
      &:nth-child(2) {
        opacity: 0;
        left: -60px;
      }
      &:nth-child(3) {
        top: 7px;
        transform: rotate(-135deg);
      }
    }
  }
}
</style>
